const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Content Manager Directive to display a list or table with content to manage
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Admin Content the resource defined to get and set Admin Content data
 */
app.directive('contentManager', ['Application', 'Authorization', 'AdminContent', 'Viewables', 'Articles', 'Files', 'Videos', 'Tracks', 'Workshops', 'MultiSessionWorkshops', 'AccessHelper', '$translate', function(Application, Authorization, AdminContent, Viewables, Articles, Files, Videos, Tracks, Workshops, MultiSessionWorkshops, AccessHelper, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        // tabName: '=',
        refresh: '=',
        pending: '@?',
        myContent: '@?',
        singleType: '@?'
      },
      template: require('../../templates/directives/content-manager.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.features = Application.features.flags();
          self.assignmentsV2 = Application.features.useAssignmentsV2();
          self.noNext = false;
          self.showDeleteConfirmation = false;
          self.directory = {};
          self.content = [];
          self.per_page = $scope.singleType ? 20 : 5;
          self.selection = [];
          self.contentRemoved = 0;
          self.loading = false;
          self.translations = {};
          self.allTypes = true;
          self.myContentOnly = $scope.myContent ? 'yes' : 'no';
          self.pendingContent = $scope.pending ? 'yes' : 'no';
          self.requestedTypes = {
            articles: false,
            videos: false,
            files: false,
            tracks: false
          };

          if (self.features.scorm) {
            self.requestedTypes.scorm = false;
          }

          if (self.features.udemy || self.features.linkedin_learning || self.features.enable_masterclass) {
            self.requestedTypes.imported_content = false;
          }

          if (self.features.presentations) {
            self.requestedTypes.presentations = false;
          }

          if ($scope.singleType && $scope.singleType === 'workshop') {
            self.requestedTypes = {workshops: true};
          }

          if ($scope.singleType && $scope.singleType === 'assessment') {
            self.requestedTypes = {assessments: true};
          }

          self.typeLink = {
            article: 'articles',
            video: 'videos',
            file: 'files',
            track: 'tracks',
            scorm: 'scorm',
            imported_content: 'imported-content',
            presentation: 'presentations',
            workshop: 'workshops',
            multi_session_workshop: 'multi-session-workshops',
            assessment: 'assessments'
          };

          self.typeToCapital = {
            track: "Track",
            multi_session_workshop: "Multi Session Workshop",
            workshop: "Workshop",
            article: "Article",
            video: "Video",
            file: "File"
          }

          self.allTypeList = Object.keys(self.requestedTypes);
          self.allTypeString = self.allTypeList.join(',');

          self.assignment = {
            selection: [],
            show: false,
            select: function() {
              self.assignment.selection.splice(0);
              for (var i = 0; i < self.selection.length; i++) {
                self.assignment.selection.push(self.directory[self.selection[i]]);
              }

              if (self.assignmentsV2) {
                Application.storage.put('learn-app-assignment-content-selection', self.assignment.selection);
              }

              self.assignmentsV2 ? window.location.replace('/admin/assignments/create') : self.assignment.show = true;
            },
            cancel: function() {
              self.assignment.show = false;
            }
          };

          self.isCollaborator = function() {
            return Authorization.isCollaborator();
          };

          self.allowance = {
            archived: !self.isCollaborator() && AccessHelper.isAllowed(['admin', 'content', 'archive_content'], null, ['admin', 'creator', 'collaborator']),
            assign: !self.isCollaborator() && AccessHelper.isAllowed(['admin', 'assignments', 'create'], null, ['admin']),
            create_article: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'articles_create']], ['admin', 'creator', 'collaborator']),
            edit_article: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'articles_edit']], ['admin', 'creator', 'collaborator']),
            host_article: AccessHelper.isAllowed(['admin', 'content', 'all_analytics'], [['admin', 'content', 'articles_analytics']], ['admin', 'creator', 'collaborator']),
            create_file: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'files_create']], ['admin', 'creator', 'collaborator']),
            edit_file: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'files_edit']], ['admin', 'creator', 'collaborator']),
            host_file: AccessHelper.isAllowed(['admin', 'content', 'all_analytics'], [['admin', 'content', 'files_analytics']], ['admin', 'creator', 'collaborator']),
            create_video: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'videos_create']], ['admin', 'creator', 'collaborator']),
            edit_video: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'videos_edit']], ['admin', 'creator', 'collaborator']),
            host_video: AccessHelper.isAllowed(['admin', 'content', 'all_analytics'], [['admin', 'content', 'videos_analytics']], ['admin', 'creator', 'collaborator']),
            create_workshop: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'workshops_create']], ['admin', 'creator', 'collaborator']),
            create_multi_session_workshop: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'workshops_create']], ['admin', 'creator', 'collaborator']),
            edit_workshop: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'workshops_edit']], ['admin', 'creator', 'collaborator']),
            host_workshop: AccessHelper.isAllowed(['admin', 'content', 'all_analytics'], [['admin', 'content', 'workshops_analytics']], ['admin', 'creator', 'collaborator']),
            host_multi_session_workshop: AccessHelper.isAllowed(['admin', 'content', 'all_analytics'], [['admin', 'content', 'workshops_analytics']], ['admin', 'creator', 'collaborator']),
            create_track: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'tracks_create']], ['admin', 'creator', 'collaborator']),
            edit_track: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'tracks_edit']], ['admin', 'creator', 'collaborator']),
            host_track: AccessHelper.isAllowed(['admin', 'content', 'all_analytics'], [['admin', 'content', 'tracks_analytics']], ['admin', 'creator', 'collaborator']),
            // No duplicating presentations
            create_presentation: false,
            edit_presentation: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'presentations_edit']], ['admin', 'creator', 'collaborator']),
            host_presentation: AccessHelper.isAllowed(['admin', 'content', 'all_analytics'], [['admin', 'content', 'presentations_analytics']], ['admin', 'creator', 'collaborator']),
            // false because scorm can't be duplicated
            create_scorm: false,
            edit_scorm: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'scorm_edit']], ['admin', 'creator', 'collaborator']),
            host_scorm: AccessHelper.isAllowed(['admin', 'content', 'all_analytics'], [['admin', 'content', 'scorm_analytics']], ['admin', 'creator', 'collaborator']),
            create_imported_content: false,
            edit_imported_content: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'imported_content_edit']], ['admin', 'creator', 'collaborator']),
            host_imported_content: AccessHelper.isAllowed(['admin', 'content', 'all_analytics'], [['admin', 'content', 'imported_content_analytics']], ['admin', 'creator', 'collaborator']),
            create_assessment: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'assessments_create']], ['admin', 'creator', 'collaborator']),
            edit_assessment: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'assessments_edit']], ['admin', 'creator', 'collaborator']),
            host_assessment: AccessHelper.isAllowed(['admin', 'content', 'all_analytics'], [['admin', 'content', 'assessments_analytics']], ['admin', 'creator', 'collaborator']),
            allowHost: function(type) {
              if (!self.isCollaborator() && self.allowance['host_' + type]) {
                return true;
              }
              let myContentAnalytics = AccessHelper.isAllowed(['admin', 'content', 'all_analytics'], [['admin', 'content', 'my_content_analytics']], ['admin', 'creator', 'collaborator']);
              if($scope.myContent && myContentAnalytics) {
                return true;
              }
              return false;
            },
            allowCreate: function(type) {
              return !!self.allowance['create_' + type]
            }
          };


          self.showDuplicateButton = function() {
            var content_selected = self.selection.length === 1 && self.selection[0] && self.directory[self.selection[0]];
            var not_scorm_or_ic = content_selected && (self.directory[self.selection[0]].type !== 'scorm' && self.directory[self.selection[0]].type !== 'imported_content');
            var not_collaborator = !(self.user && self.user.is_collaborator === true);
            if (content_selected && not_scorm_or_ic && not_collaborator) {
              if (!self.allowance.allowCreate(self.directory[self.selection[0]].type)) {
                return false;
              }
              return true;
            }

            return false;
          };

          self.pageSet = function() {
            if ($scope.singleType) {
              return 20;
            }
            var types = self.allTypes ? self.allTypeList : Object.keys(self.requestedTypes).reduce(function (acc, item) {
              if (self.requestedTypes[item]) {
                acc.push(item);
              }
              return acc;
            }, []);

            var originalLength = self.allTypeList.length;
            self.per_page = Math.ceil((originalLength * 5) / types.length);
            if (self.query) {
              self.query.per_page = self.per_page;
            }
          };

          self.getStandardQuery = function() {
            var types = self.allTypes ? self.allTypeList : Object.keys(self.requestedTypes).reduce(function (acc, item) {
              if (self.requestedTypes[item]) {
                acc.push(item);
              }
              return acc;
            }, []);

            self.pageSet();

            var q = {
              page: 1,
              per_page: self.per_page,
              'user-populate': 'first_name,last_name,full_name,email',
              sort: 'updatedAt,-1',
              types: types.join(',')
            };

            if ($scope.pending) {
              q.approval_required = true;
              q.sort = 'approved,1';
            }

            if ($scope.myContent && !self.isCollaborator()) {
              q.user = Application.access.user._id;
            }

            return q;
          };

          self.query = self.getStandardQuery();

          self.initialize = function() {
            self.initialized = true;
            self.load();
          };

          self.select = function(item) {
            var id = item._id;
            var index = self.selection.indexOf(id);
            if (index === -1) {
              self.selection.push(id);
              self.directory[id] = item;
              return;
            }
            for (var i = 0; i < self.assignment.selection.length; i++) {
              if (self.assignment.selection[i]._id && self.assignment.selection[i]._id.toString() === item._id.toString()) {
                self.assignment.selection.splice(i, 1);
                break;
              }
            }
            self.selection.splice(index, 1);
            delete self.directory[id];
          };

          self.removeSelections = function() {
            for (var i = self.selection.length - 1; i >= 0; i--) {
              self.select(self.directory[self.selection[i]]);
            }
            self.assignment.selection.splice(0);
          };

          self.resetTypes = function(override) {
            var all = true;
            var allFalse = true;
            for (var key in self.requestedTypes) {
              if (!self.requestedTypes[key]) {
                all = false;
                continue;
              }
              allFalse = false;
            }
            var types = self.allTypeString;
            if (!all && !allFalse && !override) {
              self.allTypes = false;
              types = Object.keys(self.requestedTypes).reduce(function (acc, item) {
                if (self.requestedTypes[item]) {
                  acc.push(item);
                }
                return acc;
              }, []).join(',');
            }

            if (override || all || allFalse) {
              self.allTypes = true;
              for (var key in self.requestedTypes) {
                self.requestedTypes[key] = false;
              }
            }

            self.query.page = 1;
            self.query.types = types;
            self.pageSet();
            self.load();
          }

          self.getLink = function(type, content) {
            if (!content.type || !self.typeLink[content.type]) {
              return '/';
            }

            return '/' + type + '/' + self.typeLink[content.type] + '/' + content._id;
          };

          self.editContent = function(content) {
            if (!content.type) {
              return;
            }
            var allowanceType = content.type === 'imported-content' ? 'imported_content' : content.type === 'multi_session_workshop' ? 'workshop' : content.type;
            if (!self.allowance['edit_' + allowanceType]) {
              let myContentEdit = AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'my_content_edit']], ['admin', 'creator', 'collaborator']);
              if(!$scope.myContent || !myContentEdit) {
                return;
              }
            }

            Application.navigation.goTo(self.getLink('edit', content));
          };

          self.load = function() {
            self.loading = true;
            self.contentLoading = true;

            AdminContent.findAnalytics(self.query).$promise
            .then(function(results) {
              self.noNext = !results.next_exists;

              self.content = results.data;
              self.contentRemoved = 0;
              var sortField = 'updatedAt';
              if ($scope.pending) {
                sortField = 'approved';
              }

              self.content.sort(function(a, b) {
                if ($scope.pending){
                  return a[sortField] - b[sortField];
                }
                if (!b[sortField] || !a[sortField]) {
                  return b[sortField] - a[sortField];
                }
                return new Date(b[sortField]) - new Date(a[sortField]);
              });


              self.loading = false;
              self.contentLoading = false;
            }, function(error) {
              self.contentLoading = false;
              console.error('Error getting content:', error);
            });
          };

          self.previous = function() {
            if (self.query.page === 1) {
              return;
            }
            self.query.page--;
            self.load();
          };
          self.next = function() {
            if (self.noNext) {
              return;
            }
            self.query.page++;
            self.load();
          };

          self.searchItems = {
            placeholder: self.translations['contentManager.search_placeholder'],
            onQuery: function(opts) {
              self.query = self.getStandardQuery();
              self.query.page = 1;
              self.searching = false;
              if (opts && typeof opts === 'object' && Object.keys(opts).length) {
                self.searching = true;
              }
              if (!opts) {
                self.load();
                return;
              }

              for (var key in opts) {
                self.query[key] = opts[key];
              }
              self.load();
            }
          };

          self.confirmArchive = function() {
            self.showArchiveConfirmation = true;
          };
          self.cancelArchive = function() {
            self.selection.length = 0;
            self.showArchiveConfirmation = false;
          };
          self.archive = function() {
            var selection = [];
            self.archiveInfo = {
              show: false,
              attemptedContents: []
            };
            if (self.selection.length === 0 || self.content.length === 0) {
              return;
            }
            for (var i = 0; i < self.content.length; i++) {
              var content = self.content[i];
              if (self.selection.indexOf(content._id) === -1) {
                continue;
              }
              self.archiveInfo.attemptedContents.push(content);
              selection.push({id: content._id, type: content.type});
            }
            self.loading = true;
            Viewables.archive({}, {content: selection}, function(results) {
              self.archiveInfo.results = results;
              results.archived.forEach(function(archivedItem) {
                for (var index = self.content.length; index >= 0; index--) {
                  if (!self.content[index] || !self.content[index]._id || self.content[index]._id !== archivedItem) {
                    continue;
                  }
                  self.content.splice(index, 1);
                  self.contentRemoved++;
                  break;
                }
              });
              self.archiveInfo.show = results.in_track?.length || results.in_workflow?.length || results.in_journey?.length;

              if (!self.archiveInfo.show) {
                $translate('contentManager.all_archived_success').then(function(translation) {
                  Application.messaging.addMessage({type: 'success', duration: 5, text: translation});
                });
              }
              $scope.refresh = 'archived';
              self.cancelArchive();
              self.loading = false;
            }, function(error) {
              console.error('Error archiving content:', error);
              self.cancelArchive();
            });
          };

          self.confirmDuplicate = function() {
            if (self.selection.length !== 1 || !self.directory[self.selection[0]] || self.duplicateLoading) {
              return;
            }
            self.toDuplicate = self.directory[self.selection[0]];
            self.showDuplicate = true;

          };

          self.duplicateItem = function() {
            if (self.duplicateLoading) {
              return;
            }
            self.duplicateLoading = true;
            var contentPromise;
            var type = self.toDuplicate.type;
            if (type === 'article') {
              contentPromise = Articles.duplicate({subresource: self.toDuplicate._id}, {}).$promise;
            }
            if (type === 'file') {
              contentPromise = Files.duplicate({subresource: self.toDuplicate._id}, {}).$promise;
            }
            if (type === 'video') {
              contentPromise = Videos.duplicate({subresource: self.toDuplicate._id}, {}).$promise;
            }
            if (type === 'track') {
              contentPromise = Tracks.duplicate({subresource: self.toDuplicate._id}, {}).$promise;
            }
            if (type === 'workshop') {
              contentPromise = Workshops.duplicate({subresource: self.toDuplicate._id}, {}).$promise;
            }
            if (type === 'multi_session_workshop') {
              contentPromise = MultiSessionWorkshops.duplicate({subresource: self.toDuplicate._id}, {userId: Application.access.user._id}).$promise;
            }

            if (!contentPromise) {
              self.duplicateLoading = false;
              return;
            }
            contentPromise.then(function(item) {
              self.load();
              self.duplicateLoading = false;
              self.showDuplicate = false;
              self.removeSelections();
            }).catch(function(error) {
              // handle error
              console.error('error in workshop duplication', error);
            });
          };

          self.onExplore = function(content) {
            return !content.explore_hide && self.published(content);
          };

          self.published = function(content) {
            if ((content.type === 'imported_content' || content.type === 'workshop' || content.type === 'multi_session_workshop') && !content.published) {
              return false;
            }

            return !content.draft && !content.transcoding && (!content.approval_required || (content.approval_required && content.approved));
          };

          $translate([
            'smartbar.placeholder.content',
            'modules.notifications.content_selectedAssigned',
            'modules.notifications.content_selectedDeleted',
            'contentManager.search_placeholder'
          ]).then(function(translations) {
            self.translations = translations;
          });

          self.initialize();

          // if (!$scope.tabName || $scope.tabName === 'content') {
          //   self.initialize();
          //   return;
          // }

          $scope.$watch('refresh', function(newVal, oldVal) {
            if (!self.initialized || !newVal || newVal === oldVal || newVal !== 'content' || newVal !== 'all') {
              return;
            }
            self.load();
            $scope.refresh = null;
          });
          // var tabWatch = $scope.$watch('tabName', function(newVal, oldVal) {
          //   if (newVal === 'content') {
          //     self.initialize();
          //     tabWatch();
          //   }
          // });
        }],
      controllerAs: 'manager'
    };
  }]);
